/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unsafe-storage */

import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

// @ts-expect-error dependency missing types
import rootReducer from '../reducers';
// @ts-expect-error dependency missing types
import LocalStoragePersistenceMiddleware from '../middleware/LocalStoragePersistenceMiddleware';
// @ts-expect-error dependency missing types
import RavenErrorReportingMiddleware from '../middleware/RavenErrorReportingMiddleware';
// @ts-expect-error dependency missing types
import CacheMiddleware from '../middleware/CacheMiddleware';
// @ts-expect-error dependency missing types

export function configureStore(initialState) {
  return createStore(rootReducer, initialState, compose(applyMiddleware(thunk, CacheMiddleware, LocalStoragePersistenceMiddleware, RavenErrorReportingMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f));
}